<!-- src/routes/join.svelte -->
<script>
  import SignupForm from '../components/common/SignupForm.svelte';
  import { onMount } from 'svelte';
  
  onMount(() => {
    // Add meta robots tag to prevent indexing
    const metaRobots = document.createElement('meta');
    metaRobots.name = 'robots';
    metaRobots.content = 'noindex, nofollow';
    document.head.appendChild(metaRobots);
  });
</script>

<section class="signup_section">
  <div class="content_wrapper">
    <h1 class="marker-font">Join Down to Earth Guides</h1>
    <p class="intro">Join business leaders gaining a competitive edge through clear, jargon-free AI insights.</p>
    
    <div class="benefits">
      <h2>What You'll Receive:</h2>
      <ul>
        <li>Eight deep-dive explanations of the key AI breakthroughs reshaping business</li>
        <li>Plain English translations of technical concepts without the jargon</li>
        <li>Step-by-step implementation guides for each AI breakthrough in your business</li>
        <li>Priority access to future resources and events</li>
      </ul>
    </div>

    <SignupForm />
  </div>
</section>

<style>
  .signup_section {
    padding: 4rem 1rem;
    min-height: 100vh;
    display: flex;
    align-items: center;
    background: var(--color-background);
    color: var(--color-text);
  }

  .content_wrapper {
    max-width: 800px;
    margin: 0 auto;
    text-align: center;
  }

  h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: var(--color-primary);
  }

  .intro {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    color: var(--color-text-muted);
  }

  .benefits {
    margin: 2rem auto;
    max-width: 600px;
    text-align: left;
    background: var(--color-card-bg);
    padding: 2rem;
    border-radius: 12px;
    margin-bottom: 3rem;
  }

  .benefits h2 {
    color: var(--color-primary);
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }

  .benefits ul {
    list-style: none;
    padding: 0;
  }

  .benefits li {
    margin-bottom: 1rem;
    padding-left: 2rem;
    position: relative;
  }

  .benefits li::before {
    content: "✓";
    position: absolute;
    left: 0;
    color: var(--color-primary);
    font-weight: bold;
  }

  @media (max-width: 768px) {
    .signup_section {
      padding: 2rem 1rem;
    }

    h1 {
      font-size: 2rem;
    }

    .benefits {
      padding: 1.5rem;
      margin-bottom: 2rem;
    }
  }
</style> 